/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type OperatingModeEnum = typeof OperatingModeEnum[keyof typeof OperatingModeEnum];


export const OperatingModeEnum = {
  off: 'off',
  priority_switch: 'priority_switch',
  automatic: 'automatic',
  manual: 'manual',
  timer: 'timer',
} as const;
